// Why a friend request was refused (apps/edge/src/friendships.ts): declined before, today's 50 used,
// or too many in a minute. `{when}` is a relative time ("over 28 dagen") from Intl.RelativeTimeFormat.
// One entry per locale; every key exists in all seven (nl is the source, the rest are translations).
export const friendRequestsCopy = {
  nl: {
    "social.friends.request.declined":
      "Dit verzoek is eerder afgewezen. Je kunt {when} opnieuw vragen.",
    "social.friends.request.dailyLimit":
      "Je hebt vandaag het maximum aan vriendverzoeken bereikt. Probeer het {when} opnieuw.",
    "social.friends.request.burst": "Te veel verzoeken kort na elkaar. Probeer het {when} opnieuw.",
  },
  en: {
    "social.friends.request.declined":
      "This request was declined before. You can ask again {when}.",
    "social.friends.request.dailyLimit":
      "You have reached today's limit of friend requests. Try again {when}.",
    "social.friends.request.burst": "Too many requests in a row. Try again {when}.",
  },
  de: {
    "social.friends.request.declined":
      "Diese Anfrage wurde schon einmal abgelehnt. Du kannst {when} erneut fragen.",
    "social.friends.request.dailyLimit":
      "Du hast das Limit für Freundschaftsanfragen von heute erreicht. Versuch es {when} wieder.",
    "social.friends.request.burst":
      "Zu viele Anfragen kurz hintereinander. Versuch es {when} wieder.",
  },
  fr: {
    "social.friends.request.declined":
      "Cette demande a déjà été refusée. Tu pourras la renvoyer {when}.",
    "social.friends.request.dailyLimit":
      "Tu as atteint la limite de demandes d'ami pour aujourd'hui. Réessaie {when}.",
    "social.friends.request.burst": "Trop de demandes à la suite. Réessaie {when}.",
  },
  es: {
    "social.friends.request.declined":
      "Esta solicitud se rechazó antes. Podrás volver a enviarla {when}.",
    "social.friends.request.dailyLimit":
      "Has llegado al límite de solicitudes de amistad de hoy. Inténtalo de nuevo {when}.",
    "social.friends.request.burst": "Demasiadas solicitudes seguidas. Inténtalo de nuevo {when}.",
  },
  it: {
    "social.friends.request.declined":
      "Questa richiesta era già stata rifiutata. Potrai riprovare {when}.",
    "social.friends.request.dailyLimit":
      "Hai raggiunto il limite di richieste di amicizia di oggi. Riprova {when}.",
    "social.friends.request.burst": "Troppe richieste una dopo l'altra. Riprova {when}.",
  },
  pt: {
    "social.friends.request.declined":
      "Este pedido já foi recusado antes. Podes voltar a pedir {when}.",
    "social.friends.request.dailyLimit":
      "Chegaste ao limite de pedidos de amizade de hoje. Tenta de novo {when}.",
    "social.friends.request.burst": "Demasiados pedidos seguidos. Tenta de novo {when}.",
  },
} as const;
